import { render, staticRenderFns } from "./MemberSearchPopComp.vue?vue&type=template&id=10a4069a&scoped=true"
import script from "./MemberSearchPopComp.vue?vue&type=script&lang=js"
export * from "./MemberSearchPopComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a4069a",
  null
  
)

export default component.exports